// LiveView transport failures can arrive on asynchronous Phoenix callbacks,
// without pushWithReply/pushHookEvent in the stack (BRAINBOX-P). At this point
// frames are still minified, so source-mapped filenames cannot identify them.
const DISCONNECTED = 'unable to push hook event. LiveView not connected'
const UNMATCHED_TOPIC = 'failed with reason: {"reason":"unmatched topic"}'

function isExpectedTransportRejection (exception) {
  if (exception.mechanism?.handled === true) {return false}

  if (exception.value === DISCONNECTED) {return true}

  // Only this exact Phoenix reply is expected channel-loss noise. Do not hide
  // arbitrary server errors merely because pushWithReply appears in the stack.
  if (exception.type === 'Error' && exception.value === UNMATCHED_TOPIC) {
    const mechanism = exception.mechanism?.type || ''
    return /^(?:auto\.browser\.global_handlers\.)?onunhandledrejection$/.test(mechanism)
  }

  // A timeout can mean a lost user action. A Phoenix frame identifies the
  // transport, not whether the action was harmless (BRAINBOX-H).
  return false
}

/**
 * Identify events whose entire exception chain consists of recognized,
 * unhandled LiveView transport rejections. Empty or mixed chains are retained.
 * @param {object} event - The Sentry event to inspect before reporting it.
 * @returns {boolean} Whether every exception matches expected transport noise.
 */
export function isBenignLiveViewRejection (event) {
  const values = event.exception?.values
  // A real error chained with an expected rejection must still be reported.
  return Boolean(values?.length) && values.every(isExpectedTransportRejection)
}
